import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/home-asx";
// import Equipment from "@/components/equipment";
import Products from "@/components/firstLevel/products";
import About from "@/components/firstLevel/About";
import Markets from "@/components/firstLevel/Markets";
import Contact from "@/components/firstLevel/Contact";
import Events from "@/components/firstLevel/Events";
import Privacy from "@/components/firstLevel/Privacy.vue";
import Terms from "@/components/firstLevel/Terms.vue";
// import Investors from "@/components/firstLevel/Investors";
// import WhatWeDo from "@/components/firstLevel/WhatWeDo";

import SearchList from "../components/Products/SearchList.vue";

// import Pogopin_Single from "@/components/Products/PogopinProbes/Single";
// import Pogopin_Connector from "@/components/Products/PogopinProbes/Connector";
// import Pogopin_Waterproof from "@/components/Products/PogopinProbes/Waterproof";
// import Pogopin_Magnetic from "@/components/Products/PogopinProbes/Magnetic";

import Pogopin_Probes from "@/components/Products/PogopinProbes/PogopinProbes";

// import TestingProbes_IC_Test from "@/components/Products/TestingProbes/IC_Test";
// import TestingProbes_ICT from "@/components/Products/TestingProbes/ICT";
// import TestingProbes_HightCurrent from "@/components/Products/TestingProbes/HightCurrent";
import TestingProbes from "@/components/Products/TestingProbes/TestingProbes";

import IndustryConnector from "@/components/Products/IndustryConnector/IndustryConnector";

import HardwareComponents from "@/components/Products/HardwareComponents/HardwareComponents";

// import IndustryConnector_PlugSocket from "@/components/Products/IndustryConnector/PlugSocket";
// import IndustryConnector_Circular from "@/components/Products/IndustryConnector/Circular";
// import IndustryConnector_Rectangular from "@/components/Products/IndustryConnector/Rectangular";

// import HardwareComponents_Communication from "@/components/Products/HardwareComponents/Communication";
// import HardwareComponents_Medical from "@/components/Products/HardwareComponents/Medical";
// import HardwareComponents_AeroSpace from "@/components/Products/HardwareComponents/AeroSpace";

import newsTestProbeIntro from "@/components/News/TestProbeIntro";
import newsPogopinProbeIntro from "@/components/News/PogopinProbeIntro";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "/products",
      name: "Products",
      component: Products,
    },
    {
      path: "/about",
      name: "About",
      component: About,
    },
    {
      path: "/markets",
      name: "Markets",
      component: Markets,
    },
    {
      path: "/events",
      name: "Events",
      component: Events,
    },
    {
      path: "/contact",
      name: "Contact",
      component: Contact,
    },
    {
      path: "/terms",
      name: "Terms",
      component: Terms,
    },
    {
      path: "/privacy",
      name: "Privacy",
      component: Privacy,
    },
    {
      path: "/searchlist",
      name: "SearchList",
      component: SearchList,
    },
    {
      path: "/Pogopin_Probes",
      name: "Pogopin_Probes",
      component: Pogopin_Probes,
    },
    {
      path: "/TestingProbes",
      name: "TestingProbes",
      component: TestingProbes,
    },
    {
      path: "/IndustryConnector",
      name: "IndustryConnector",
      component: IndustryConnector,
    },
    {
      path: "/HardwareComponents",
      name: "HardwareComponents",
      component: HardwareComponents,
    },
    {
      path: "/newsTestProbeIntro",
      name: "newsTestProbeIntro",
      component: newsTestProbeIntro,
    },
    {
      path: "/newsPogopinProbeIntro",
      name: "newsPogopinProbeIntro",
      component: newsPogopinProbeIntro,
    },
    // {
    //   path: "/Pogopin_Single",
    //   name: "Pogopin_Single",
    //   component: Pogopin_Single,
    // },
    // {
    //   path: "/Pogopin_Connector",
    //   name: "Pogopin_Connector",
    //   component: Pogopin_Connector,
    // },
    // {
    //   path: "/Pogopin_Waterproof",
    //   name: "Pogopin_Waterproof",
    //   component: Pogopin_Waterproof,
    // },
    // ,
    // {
    //   path: "/Pogopin_Magnetic",
    //   name: "Pogopin_Magnetic",
    //   component: Pogopin_Magnetic,
    // },
    // {
    //   path: "/TestingProbes_ICT",
    //   name: "TestingProbes_ICT",
    //   component: TestingProbes_ICT,
    // },
    // {
    //   path: "/TestingProbes_IC_Test",
    //   name: "TestingProbes_IC_Test",
    //   component: TestingProbes_IC_Test,
    // },
    // ,
    // {
    //   path: "/TestingProbes_HightCurrent",
    //   name: "TestingProbes_HightCurrent",
    //   component: TestingProbes_HightCurrent,
    // },

    // {
    //   path: "/IndustryConnector_PlugSocket",
    //   name: "IndustryConnector_PlugSocket",
    //   component: IndustryConnector_PlugSocket,
    // },
    // {
    //   path: "/IndustryConnector_Circular",
    //   name: "IndustryConnector_Circular",
    //   component: IndustryConnector_Circular,
    // },
    // ,
    // {
    //   path: "/IndustryConnector_Rectangular",
    //   name: "IndustryConnector_Rectangular",
    //   component: IndustryConnector_Rectangular,
    // },
    // {
    //   path: "/HardwareComponents_Communication",
    //   name: "HardwareComponents_Communication",
    //   component: HardwareComponents_Communication,
    // },
    // {
    //   path: "/HardwareComponents_Medical",
    //   name: "HardwareComponents_Medical",
    //   component: HardwareComponents_Medical,
    // },
    // ,
    // {
    //   path: "/HardwareComponents_AeroSpace",
    //   name: "HardwareComponents_AeroSpace",
    //   component: HardwareComponents_AeroSpace,
    // },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js